"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const constants = __importStar(require("@/common/constants"));
const GameOverview_vue_1 = __importDefault(require("@/client/components/admin/GameOverview.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'games-overview',
    data() {
        return {
            entries: [],
        };
    },
    mounted() {
        this.getGames();
    },
    components: {
        GameOverview: GameOverview_vue_1.default,
    },
    methods: {
        async getGames() {
            try {
                const response = await fetch('api/games?serverId=' + this.serverId);
                if (!response.ok) {
                    alert('Unexpected response fetching games from API');
                    return;
                }
                const result = await response.json();
                if (result instanceof Array) {
                    this.entries = result.map((response) => ({
                        id: response.gameId,
                        game: undefined,
                        status: 'loading',
                    }));
                    this.entries.forEach((_, idx) => this.getGame(idx));
                }
                else {
                    alert('Unexpected response fetching games from API');
                }
            }
            catch (error) {
                alert('Error getting games data');
            }
        },
        async getGame(idx) {
            if (idx >= this.entries.length) {
                return;
            }
            const entry = this.entries[idx];
            const gameId = entry.id;
            try {
                const response = await fetch('api/game?id=' + gameId);
                if (response.ok) {
                    const game = await response.json();
                    entry.status = 'done';
                    entry.game = game;
                }
                else {
                    entry.status = 'error';
                }
            }
            catch (error) {
                entry.status = 'error';
            }
        },
    },
    computed: {
        constants() {
            return constants;
        },
        serverId() {
            return (new URL(location.href)).searchParams.get('serverId') || '';
        },
    },
});
